const whitelabel = {
  state: {
    whitelabel: {
      enabled: false,
      theme: 'pagarme',
      url: process.env.VUE_APP_BASE_URL,
      domain: '.pagar.me'
    }
  },
  getters: {
    whitelabel (state) {
      return state.whitelabel
    }
  },
  mutations: {
    updateWhitelabel (state, value) {
      state.whitelabel = value
    },
    updateWhitelabelTheme (state, value) {
      state.whitelabel.theme = value
    }
  },
  actions: {
    UPDATE_WHITELABEL ({ commit }, value) {
      commit('updateWhitelabel', value)
    }
  }
}
export default whitelabel
